import { Typography } from "@mui/material";
import React from "react";

export default function Content({ paragraph, children }) {
  return (
    <Typography paragraph={paragraph} sx={{ pt: 1, lineHeight: 1.8 }}>
      {children}
    </Typography>
  );
}
